/* Extra storefront interactions only. Google & YouTube owns the base tag and ecommerce events. */
(() => {
  if (window.TisFunnelEventsReady || window.Shopify?.designMode) return;
  window.TisFunnelEventsReady = true;
  const measurementId = 'G-RM2W0L7FSM';
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {}); }
    catch (_) { /* Unknown consent means these optional events are not sent. */ }
  }
  const productPath = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname) ? url.pathname : null;
    } catch (_) { return null; }
  };
  const send = (name, value, surface, productId) => {
    const path = productPath(value);
    if (!path || !/^[1-9]\d{0,19}$/.test(String(productId || ''))) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      if (typeof window.gtag !== 'function') return;
      // Reuse the existing tag/session. Never configure a new tag, replay ecommerce,
      // change consent, read cookies, or queue actions performed before consent.
      window.gtag('event', name, {
        send_to: measurementId,
        // GA4 custom values have a 100-character limit. The ID is the stable key.
        product_path: path.slice(0, 100),
        product_id: String(productId),
        surface,
        schema_version: 2,
      });
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  };
  document.addEventListener('tis:preview-opened', event => {
    send('tis_preview_opened', event.detail?.productPath, 'quick_view', event.detail?.productId);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-tis-live-demo]');
    if (!link || event.defaultPrevented || (event.button !== undefined && event.button !== 0)) return;
    send('tis_live_demo_clicked', link.dataset.tisProductPath,
      link.closest('[data-quick-view-dialog]') ? 'quick_view' : 'product_page', link.dataset.tisProductId);
  });
})();
